import { styled } from 'styled-components';

import { getReadableMonthAndYearFromPayMonth } from '@fora-monorepo/employer-my-pages-common/utils';
import { Assets, Button, Container, Flex, Headings, Line, Text, theme } from '@foradevelopment/fora-ui';

import { ReportType } from './types';
import { useTypedTranslation } from '../../i18n/i18n';

const StyledButton = styled(Button)`
  border-color: ${theme.colors.black};
  @media print {
    display: none;
  }
`;

type ReportHeaderProps = {
  reportType: ReportType;
  reportDate: string;
  organizationName: string;
  organizationNumber: string;
  payMonths?: string[];
};

/** Inrapporteringskvittens (summary) or avvikelserapport */
export const ReportHeader = ({
  reportType,
  reportDate,
  organizationName,
  organizationNumber,
  payMonths,
}: ReportHeaderProps) => {
  const [date, time] = reportDate.split(' ');
  const { t } = useTypedTranslation();

  return (
    <Container>
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Assets.ForaLogo width={150} color="foraBlue" />
        <Flex flexDirection="column" alignItems="flex-end" width={268}>
          <Headings.H3 marginBottom={10}>
            {reportType === 'reporting-receipt'
              ? t('common.reportModalContentLabel')
              : t('common.deviationReportLabel')}
          </Headings.H3>
          <Text color="black70" fontWeight="light">
            {reportDate ? `${date} kl. ${time}` : ''}
          </Text>
          <Text color="black70" fontWeight="light" textAlign="right">
            {organizationName}, {organizationNumber}
          </Text>
        </Flex>
      </Flex>
      <Line marginBottom={30} marginTop={30} color="black10" />
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Flex flexDirection="column" rowGap={8}>
          {payMonths && payMonths.length > 0 && (
            <Container>
              <Text color="black70" size="small" fontWeight="semibold">
                {t('section.reportDetails.reportedPeriod')}
              </Text>
              <Text>{payMonths.map(pm => getReadableMonthAndYearFromPayMonth(pm)).join(', ')}</Text>
            </Container>
          )}
        </Flex>
        <StyledButton variant="transparent" color="black" resetFlexProps onClick={window.print} fullWidth={false}>
          {t('common.actions.print')} <Assets.PrinterIcon color="black" marginLeft={8} />
        </StyledButton>
      </Flex>
    </Container>
  );
};
